var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountdownIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Fastforward-Clock--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Fastforward Clock Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fastforward-clock--time-clock-reset-stopwatch-circle-measure-loading"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1560 (Stroke)",
    fill: "#ffe70d",
    fillRule: "evenodd",
    d: "M7 2.75a0.75 0.75 0 0 1 0.75 0.75v3.575l2.136 1.282a0.75 0.75 0 1 1 -0.772 1.286l-2.5 -1.5A0.75 0.75 0 0 1 6.25 7.5v-4A0.75 0.75 0 0 1 7 2.75Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffe70d",
    fillRule: "evenodd",
    d: "M1.5 7a5.5 5.5 0 0 1 9.82 -3.405l-0.966 0.965a0.5 0.5 0 0 0 0.353 0.854H13.5a0.5 0.5 0 0 0 0.5 -0.5V2.12a0.5 0.5 0 0 0 -0.854 -0.354l-0.76 0.761a7 7 0 1 0 1.427 6.086 0.75 0.75 0 0 0 -1.46 -0.344A5.5 5.5 0 0 1 1.5 7Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountdownIconYellow);
export default __webpack_public_path__ + "static/media/countdown-icon-yellow.5e23627fdc7592fb336144fcd45e56cd.svg";
export { ForwardRef as ReactComponent };